<div class="PGChat bg-white">
    @if (!isLoggedIn) {
        <div class="PGChat-Login">
            @if (authorizationToken == null) {
                <div class="form-group mb-3">
                    <label>
                        <b>Guest name</b>
                    </label>
                    <input class="form-control" [(ngModel)]="unathorizedName" (keyup)="onUnathorizedNameKeyUp($event)"/>
                </div>
                <button class="btn btn-primary btn-block" [disabled]="canUnauthorizedLogIn()" (click)="unauthorizedLogIn()">Login as Guest</button>
            }
        </div>
    }
    @if (isLoggedIn) {
        @if (isLoading) {
            <app-pg-loading></app-pg-loading>
        }
        @if (!isLoading) {
            @if (hasAccessError) {
                <div class="text-danger">ERROR</div>
            }
            @if (!hasAccessError) {
                <div class="PGChat-Outer">
                    @if (callChannel != null) {
                        <div class="PGChat-Call {{ callCompressed ? 'PGChat-Call--Compressed border-bottom' : '' }} bg-white">
                            <div class="PGChat-Call-Header bg-light border-bottom p-1">
                                <div class="ps-2">{{ getChannelName(callChannel) }}</div>
                                @if (callConfirmed) {
                                    <div>
                                        <button class="btn btn-{{callAudioDisabled ? 'danger' : 'light'}} btn-sm" (click)="callAudioDisabled = !callAudioDisabled">
                                            <i class="fa-regular fa-microphone-slash"></i>
                                        </button>
                                        <button class="btn btn-{{callVideoDisabled ? 'danger' : 'light'}} btn-sm" (click)="callVideoDisabled = !callVideoDisabled">
                                            <i class="fa-regular fa-video-slash"></i>
                                        </button>
                                        <button class="btn btn-light btn-sm {{callCompressed ? 'text-primary' : ''}}" (click)="callCompressed = !callCompressed">
                                            <i class="fa-regular fa-message-lines"></i>
                                        </button>
                                        <button class="btn btn-light btn-sm" (click)="leaveCurrentCall()">
                                            <i class="fa-regular fa-phone-hangup text-danger"></i>
                                        </button>
                                    </div>
                                }
                            </div>
                            <div class="PGChat-Call-Frame">
                                <!-- TODO: questa parte della conferma andrebbe rifattorizzata nel componente della call -->
                                @if (!callConfirmed) {
                                    <div class="PGChat-Call-Confirm">
                                        <div>
                                            <h4 class="px-3 mb-4">You are about to join a video call</h4>
                                        </div>
                                        <div class="d-flex">
                                            <div>
                                                <button class="btn btn-{{callAudioDisabled ? 'danger' : 'light'}}" (click)="callAudioDisabled = !callAudioDisabled" [disabled]="callAudioDevicesOptions.length == 0">
                                                    <i class="fa-regular fa-fw fa-microphone{{callAudioDisabled ? '-slash' : ''}}"></i>
                                                    <span>Audio</span>
                                                </button>
                                            </div>
                                            <div class="ps-2">
                                                <app-pg-select [required]="true" [options]="callAudioDevicesOptions" [(ngModel)]="callAudioSource" display="oneLine"></app-pg-select>
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <div>
                                                <button class="btn btn-{{callVideoDisabled ? 'danger' : 'light'}}" (click)="callVideoDisabled = !callVideoDisabled" [disabled]="callVideoDevicesOptions.length == 0">
                                                    <i class="fa-regular fa-fw fa-video{{callVideoDisabled ? '-slash' : ''}}"></i>
                                                    <span>Video</span>
                                                </button>
                                            </div>
                                            <div class="ps-2">
                                                <app-pg-select [required]="true" [options]="callVideoDevicesOptions" [(ngModel)]="callVideoSource" display="oneLine"></app-pg-select>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <button class="btn btn-secondary me-1" (click)="callConfirmed = true">
                                                <i class="fa-regular fa-fw fa-phone-hangup"></i>
                                                <span>Leave</span>
                                            </button>
                                            <button class="btn btn-primary ms-1" (click)="callConfirmed = true">
                                                <i class="fa-regular fa-fw fa-phone"></i>
                                                <span>Join</span>
                                            </button>
                                        </div>
                                    </div>
                                }
                                @if (callConfirmed) {
                                    <app-pg-call [callToken]="callToken" [callChannel]="callChannel" [callURL]="callURL" [disableAudio]="callAudioDisabled" [disableVideo]="callVideoDisabled" [audioSource]="callAudioSource" [videoSource]="callVideoSource"></app-pg-call>
                                }
                            </div>
                        </div>
                    }
                    <div class="PGChat-Middle">
                    <div class="PGChat-Inner">
                        @if (mode == 'customer-care' && !isGuest) {
                            <div class="PGChat-Channels p-2 border-end pg-animation-slideright">
                                @for (channel of channelList; track channel) {
                                    @if (isCustomerCareChannel(channel)) {
                                        <ng-container *ngTemplateOutlet="channelButtonTemplate;context:{ channel: channel }"></ng-container>
                                    }
                                }
                                @for (channel of channelList; track channel) {
                                    @if (isGuestChannel(channel)) {
                                        <ng-container *ngTemplateOutlet="channelButtonTemplate;context:{ channel: channel }"></ng-container>
                                    }
                                }
                                @if (customerCareWaitList.length > 0) {
                                    <div class="PGChat-Channels-Item mb-2">
                                        Waiting
                                    </div>
                                    @for (user of customerCareWaitList; track user) {
                                        <div class="PGChat-Channels-Item mb-2">
                                            <button class="btn btn-sm btn-light" (click)="openDirectOrGuestChannel(user)">
                                                <app-pg-user-status [userId]="user" [statusOverride]="'online'"></app-pg-user-status>
                                            </button>
                                        </div>
                                    }
                                }
                                @if (customerCareBookingsDay != null) {
                                    <div class="PGChat-Channels-Item mb-2">
                                        Bookings
                                    </div>
                                    @for (item of customerCareBookingsDay | keyvalue; track item) {
                                        <div class="mb-2" ngbDropdown>
                                            <button ngbDropdownToggle class="btn btn-light btn-sm">
                                                <span>{{item.key}}</span>
                                                @if (customerCareBookingStatus[item.value.pid]; as status) {
                                                    @if (status.guest.user != null) {
                                                        <app-pg-user-status [userId]="status.guest.user" [showName]="false" [statusOverride]="status.guest.online ? 'online' : 'offline'"></app-pg-user-status>
                                                    }
                                                }
                                            </button>
                                            <div ngbDropdownMenu>
                                                <div style="max-height: 400px; overflow: auto;">
                                                    <b>STATUS</b>
                                                    @if (customerCareBookingStatus[item.value.pid]; as status) {
                                                        <pre>{{status | json}}</pre>
                                                    }
                                                    <b>BOOKING</b>
                                                    <pre>{{item.value | json}}</pre>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                }
                                <div class="PGChat-Channels-Add" ngbDropdown (openChange)="onGuestSessionsOpenChange($event)">
                                    <button ngbDropdownToggle class="btn btn-light btn-sm">
                                        <i class="fa-regular fa-history"></i>
                                    </button>
                                    <div ngbDropdownMenu class="PGChat-Channels-Add-GuestSession-Menu">
                                        @if (isLoadingGuestSessions) {
                                            <app-pg-loading></app-pg-loading>
                                        }
                                        @if (!isLoadingGuestSessions) {
                                            @for (session of guestSessions; track session) {
                                                <button class="dropdown-item btn" (click)="joinGuestSession(session)">
                                                    <div>
                                                        <i class="fa fa-xs fa-circle text-{{getSessionStatusClass(session)}} me-1"></i>
                                                        <span>{{session.username}}</span>
                                                        <small class="ms-1">{{getSessionDateTime(session)}}</small>
                                                    </div>
                                                    <div class="text-muted">
                                                        <small>Session ID: {{session.session_id}}</small>
                                                    </div>
                                                </button>
                                            }
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        @if (channels[getCurrentChannel()] || (mode == 'chat' && !isGuest)) {
                            <app-pg-chat-channel
                                [ready]="channels[getCurrentChannel()]?.status != null"
                                [messages]="channels[getCurrentChannel()]?.status?.messages || []"
                                [typing]="getCurrentChannelTyping()"
                                [resolveUserName]="resolveUserName"
                                [allowAttachments]="!isGuest"
                                [disabled]="isSaving"
                                (sendMessage)="onChannelSendMessage($event)"
                                (typingChange)="onChannelTypingChange($event)"
                                (filesSelected)="onChannelFilesSelected($event)">
                                <div channelTitle class="d-flex align-items-center overflow-hidden">
                                    @if (mode == 'chat' && !isGuest) {
                                        <div ngbDropdown #channelSelectMenu="ngbDropdown" [autoClose]="'outside'" class="PGChat-ChannelSelect">
                                            <button type="button" class="btn btn-sm btn-light PGChat-ChannelSelect-Toggle" ngbDropdownToggle>
                                                <span class="PGChat-CurrentChannel-Header-Title-Text">{{ getCurrentChannel() ? getChannelName(getCurrentChannel()) : ('pg-chat.select-channel' | locTranslate) }}</span>
                                                @if (getUnreadSum(); as unread) {
                                                    <span class="badge bg-danger">{{ unread }}</span>
                                                }
                                            </button>
                                            <div ngbDropdownMenu class="PGChat-ChannelSelect-Menu">
                                                @for (ch of channelList; track ch) {
                                                    @if (!isGuestChannel(ch) && !isCustomerCareChannel(ch) && !isDirectChannel(ch)) {
                                                        <button type="button" class="dropdown-item" [class.active]="ch == getCurrentChannel()" (click)="setCurrentChannel(ch)">
                                                            @if (getChannelStatusClass(ch); as status) {
                                                                <i class="fa fa-xs fa-circle text-{{status}} me-1"></i>
                                                            }
                                                            <span>{{ getChannelName(ch) }}</span>
                                                            @if (channels[ch].unread) {
                                                                <span class="badge bg-danger ms-1">{{ channels[ch].unread }}</span>
                                                            }
                                                        </button>
                                                    }
                                                }
                                                @for (ch of channelList; track ch) {
                                                    @if (isDirectChannel(ch)) {
                                                        <button type="button" class="dropdown-item" [class.active]="ch == getCurrentChannel()" (click)="setCurrentChannel(ch)">
                                                            @if (getChannelStatusClass(ch); as status) {
                                                                <i class="fa fa-xs fa-circle text-{{status}} me-1"></i>
                                                            }
                                                            <span>{{ getChannelName(ch) }}</span>
                                                            @if (channels[ch].unread) {
                                                                <span class="badge bg-danger ms-1">{{ channels[ch].unread }}</span>
                                                            }
                                                        </button>
                                                    }
                                                }
                                                @if (channelList.length > 0) {
                                                    <div class="dropdown-divider"></div>
                                                }
                                                <div class="dropdown-item-text">
                                                    <label class="form-label mb-1">{{ 'pg-chat.join-channel' | locTranslate }}</label>
                                                    <div class="input-group input-group-sm">
                                                        <input class="form-control" [(ngModel)]="joinChannelId" (keyup)="onJoinChannelIdKeyUp($event)"/>
                                                        <button type="button" class="btn btn-primary" (click)="joinChannel()">
                                                            <i class="fa-regular fa-sign-in"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                @if (userList.length > 0) {
                                                    <div class="dropdown-item-text">{{ 'pg-chat.chat-with-user' | locTranslate }}</div>
                                                    @for (user of userList; track user) {
                                                        <button type="button" class="dropdown-item" (click)="onChatWithUserClick(user)">
                                                            <app-pg-user-status [userId]="user"></app-pg-user-status>
                                                        </button>
                                                    }
                                                }
                                            </div>
                                        </div>
                                    } @else if (getCurrentChannel()) {
                                        <div class="PGChat-CurrentChannel-Header-Title-Text">{{ getChannelName(getCurrentChannel()) }}</div>
                                    }
                                </div>
                                <div channelActions>
                                    @if (channels[getCurrentChannel()]; as channel) {
                                        @if (channel.status != null && channel.status.users != null) {
                                            <button type="button" class="btn btn-sm {{ callChannel == getCurrentChannel() ? 'btn-primary' : ('btn-light' + (getCallParticipantsCount(channel.status) > 0 ? ' text-primary' : '')) }}" (click)="joinCallCurrentChannel()" title="{{getCallParticipantsList(channel.status)}}">
                                                <i class="fa-regular fa-phone"></i> {{getCallParticipantsCount(channel.status)}}
                                            </button>
                                            <span ngbDropdown>
                                                <button type="button" class="btn btn-sm btn-light" ngbDropdownToggle>
                                                    <i class="fa-regular fa-users"></i> {{channel.status.users.length}}
                                                </button>
                                                <div ngbDropdownMenu>
                                                    @for (user of channel.status.users; track user) {
                                                        <button type="button" class="dropdown-item btn btn-sm btn-light" (click)="openDirectOrGuestChannel(user)">
                                                            <app-pg-user-status [userId]="user" [statusOverride]="isGuestUser(user) ? 'online' : null"></app-pg-user-status>
                                                        </button>
                                                    }
                                                </div>
                                            </span>
                                        }
                                        @if (!isGuest && !isCustomerCareChannel(getCurrentChannel()) && !isRealmChannel(getCurrentChannel())) {
                                            <button type="button" class="btn btn-sm btn-light" (click)="leaveCurrentChannelOrDirect()">
                                                <i class="fa-regular fa-sign-out"></i>
                                            </button>
                                        }
                                    }
                                </div>
                            </app-pg-chat-channel>
                        }
                    </div>
                </div>
            </div>
        }
    }
}
</div>

<ng-template #channelButtonTemplate let-channel="channel">
    <div class="PGChat-Channels-Item mb-2">
        <button class="btn btn-sm btn-{{ channel == getCurrentChannel() ? 'primary' : 'light' }}" (click)="setCurrentChannel(channel);">
            @if (getChannelStatusClass(channel); as status) {
                <i class="fa fa-xs fa-circle text-{{status}} me-1"></i>
            }
            <span>{{ getChannelName(channel) }}</span>
            @if (channels[channel].unread) {
                <span class="badge bg-danger">{{ channels[channel].unread }}</span>
            }
        </button>
    </div>
</ng-template>